import { AxiosResponse } from "axios";
import {
  Aluno,
  Empresa,
  EmpresaExportResponse,
  Cidade,
  Curso,
  Instituicao,
  Seguradora,
  AgenteIntegrador,
  EstagioHorario,
  PaginationParams,
  AlunoFilters,
  EmpresaFilters,
} from "@/types";
import api from "../httpClient";
import { fetchAll, fetchById, create, update, deleteById, fetchBy } from "../apiHelpers";

export const alunoService = {
  list: (filters?: AlunoFilters) => fetchAll<Aluno, AlunoFilters>("/aluno", filters),
  getById: (id: number) => fetchById<Aluno>("/aluno", id),
  create: (data: Omit<Aluno, "id" | "cidade" | "curso">) => create<Aluno>("/aluno", data),
  update: (id: number, data: Partial<Omit<Aluno, "id" | "cidade" | "curso">>) => update<Aluno>("/aluno", id, data),
  delete: (id: number) => deleteById("/aluno", id),
};

export const empresaService = {
  list: (filters?: EmpresaFilters) => fetchAll<Empresa>("/empresa", filters),
  getById: (id: number) => fetchById<Empresa>("/empresa", id),
  create: (data: Omit<Empresa, "id">) => create<Empresa>("/empresa", data),
  update: (id: number, data: Partial<Empresa>) => update<Empresa>("/empresa", id, data),
  delete: (id: number) => deleteById("/empresa", id),
  exportarLista: async (filters?: EmpresaFilters): Promise<EmpresaExportResponse> => {
    const response: AxiosResponse<EmpresaExportResponse> = await api.post("/empresa/exportar", filters ?? {});
    return response.data;
  },
};

export const cidadeService = {
  list: (filters?: PaginationParams) => fetchAll<Cidade>("/cidade", filters),
  getById: (id: number) => fetchById<Cidade>("/cidade", id),
  getByName: (nome: string) => fetchBy<Cidade>("/cidade", "nome", nome),
  getByUf: (uf: string) => fetchBy<Cidade>("/cidade", "uf", uf),
  create: (data: Omit<Cidade, "id">) => create<Cidade>("/cidade", data),
  update: (id: number, data: Partial<Cidade>) => update<Cidade>("/cidade", id, data),
  delete: (id: number) => deleteById("/cidade", id),
};

export const cursoService = {
  list: (filters?: PaginationParams) => fetchAll<Curso>("/curso", filters),
  getById: (id: number) => fetchById<Curso>("/curso", id),
  create: (data: Omit<Curso, "id">) => create<Curso>("/curso", data),
  update: (id: number, data: Partial<Curso>) => update<Curso>("/curso", id, data),
  delete: (id: number) => deleteById("/curso", id),
};

export const instituicaoService = {
  list: (filters?: PaginationParams) => fetchAll<Instituicao>("/instituicao", filters),
  getById: (id: number) => fetchById<Instituicao>("/instituicao", id),
  create: (data: Omit<Instituicao, "id">) => create<Instituicao>("/instituicao", data),
  update: (id: number, data: Partial<Instituicao>) => update<Instituicao>("/instituicao", id, data),
  delete: (id: number) => deleteById("/instituicao", id),
};

export const seguradoraService = {
  list: (filters?: PaginationParams) => fetchAll<Seguradora>("/seguradora", filters),
  getById: (id: number) => fetchById<Seguradora>("/seguradora", id),
  create: (data: Omit<Seguradora, "id">) => create<Seguradora>("/seguradora", data),
  update: (id: number, data: Partial<Seguradora>) => update<Seguradora>("/seguradora", id, data),
  delete: (id: number) => deleteById("/seguradora", id),
};

export const agenteIntegradorService = {
  list: (filters?: PaginationParams) => fetchAll<AgenteIntegrador>("/agente-integrador", filters),
  getById: (id: number) => fetchById<AgenteIntegrador>("/agente-integrador", id),
  create: (data: Omit<AgenteIntegrador, "id" | "createdAt" | "updatedAt">) => create<AgenteIntegrador>("/agente-integrador", data),
  update: (id: number, data: Partial<AgenteIntegrador>) => update<AgenteIntegrador>("/agente-integrador", id, data),
  delete: (id: number) => deleteById("/agente-integrador", id),
};

export const estagioHorarioService = {
  list: (filters?: PaginationParams) => fetchAll<EstagioHorario>("/estagio-horario", filters),
  getById: (id: number) => fetchById<EstagioHorario>("/estagio-horario", id),
  getByEstagio: (estagioId: number) => fetchBy<EstagioHorario>("/estagio-horario", "estagio", estagioId),
  create: (data: Omit<EstagioHorario, "id" | "createdAt" | "updatedAt">) => create<EstagioHorario>("/estagio-horario", data),
  createLote: async (data: {
    estagioId: number;
    diasSemana: string[];
    horarios: { horarioInicio: string; horarioFim: string }[];
  }): Promise<EstagioHorario[]> => {
    const response: AxiosResponse<EstagioHorario[]> = await api.post("/estagio-horario/lote", data);
    return response.data;
  },
  update: (id: number, data: Partial<EstagioHorario>) => update<EstagioHorario>("/estagio-horario", id, data),
  delete: (id: number) => deleteById("/estagio-horario", id),
  deleteByEstagio: async (estagioId: number): Promise<{ count: number; mensagem: string }> => {
    const response: AxiosResponse<{ count: number; mensagem: string }> = await api.delete(`/estagio-horario/estagio/${estagioId}`);
    return response.data;
  },
};
